import React, { useEffect } from 'react'
import cn from 'classnames'

import CloseIcon from 'media/close.svg?svgr-webpack'

type Props = {
  children: React.ReactNode
  heading?: string
  onClose: () => void
}

const Dialog = ({ children, onClose, heading }: Props) => {
  useEffect(() => {
    const keydownHandler = (event) => {
      if (event.keyCode === 27) {
        onClose()
      }
    }
    document.body.addEventListener('keydown', keydownHandler)
    return () => {
      document.removeEventListener('keydown', keydownHandler)
    }
  })

  return (
    <div
      role="dialog"
      aria-modal="true"
      className={cn(
        'text-grey-darkest',
        'bg-white',
        'relative',
        'bg-white',
        'rounded-8',
        'my-24',
        'mx-16',
        'pt-48',
        'pb-24 md:pb-40',
        'px-16 md:px-64',
        'text-center',
      )}
    >
      {heading && <h2 className="my-16 type-24">{heading}</h2>}
      <button
        type="button"
        className="absolute right-0 top-0 mr-16 mt-16 text-grey-darker"
        onClick={onClose}
      >
        <span className="sr-only">Close</span>
        <CloseIcon />
      </button>
      {children}
    </div>
  )
}

export default Dialog
